import { mutatorAction } from 'satcheljs';
import { mailListItemAnimationStore } from '../store/Store';
import { ActionId } from '../util/actionId';

export const setAnimationAction = mutatorAction(
    'setAnimationAction',
    (animationAction?: ActionId, animationRowIds?: string[], onAnimationComplete?: () => void) => {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (11,9): Type 'ActionId | undefined' is not assignable to type 'ActionId'.
        // @ts-expect-error
        mailListItemAnimationStore.animationAction = animationAction;
        mailListItemAnimationStore.animationRowIds = new Set(animationRowIds);
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (16,9): Type '(() => void) | undefined' is not assignable to type '() => void'.
        // @ts-expect-error
        mailListItemAnimationStore.onAnimationComplete = onAnimationComplete;
    }
);
